module.exports = __webpack_public_path__ + "img/Ankerdiebstahl.ca39c93f.jpg";